<template>
  <div class="billing-options input-group">
    <dg-input type="text" v-model="formData.registrationNumber" icon="info" placeholder="Registration number" v-if="organization.country.name === 'Denmark'"></dg-input>
    <dg-input type="text" v-model="formData.accountNumber" icon="info" placeholder="Account number" v-if="organization.country.name === 'Denmark'"></dg-input>

    <dg-input type="text" v-model="formData.bankName" icon="info" placeholder="Account number" v-if="organization.country.name !== 'Denmark'"></dg-input>
    <dg-input type="text" v-model="formData.IBAN" icon="info" placeholder="Account number" v-if="organization.country.name !== 'Denmark'"></dg-input>

    <el-button type="primary" icon="el-icon-upload" @click="updateOrganization">Save</el-button>
  </div>
</template>

<script>
export default {
  name: 'BillingOptions',
  props: {
    organization: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      formData: {
        accountNumber: '',
        registrationNumber: '',
        bankName: '',
        IBAN: ''
      }
    }
  },
  methods: {
    async updateOrganization () {
      let data = {
        currencyId: this.organization.currency.id,
        countryId: this.organization.country.id,
        accountNumber: this.formData.accountNumber,
        registrationNumber: this.formData.registrationNumber,
        bankName: this.formData.bankName,
        IBAN: this.formData.IBAN,
        transactionFee: null,
        monthlyFee: null,
        logoId: null,
        ...this.organization
      }
      const response = await this.$http.put(this.$api.organizations.update(this.organization.id), data)
      this.$message.success('Account number updated')
      this.$emit('update', response.data)
    }
  },
  created () {
    this.formData.accountNumber = this.organization.accountNumber
    this.formData.registrationNumber = this.organization.registrationNumber
    this.formData.bankName = this.organization.bankName
    this.formData.IBAN = this.organization.IBAN
  }
}
</script>

<style lang="scss" scoped>
  .billing-options {
    padding: 15px 20px 20px 20px;

    button {
      margin-top: 20px;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/BillingOptions.vue